const getCookieValue = (cookieName: string) => {
    let value = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
    return value ? value.pop() : '';
}

export default getCookieValue;